module.exports = __webpack_public_path__ + "img/index-process.13dfd54.png";